import React from 'react'
import ButtonClose from '../../atoms/button-close/button-close'
import Button from '../../atoms/button/button'
import './modalConfirm.scss'

const ModalConfirm = ({
  children,
  handleCancel = () => {},
  handleConfirm = () => {},
  noCancel = false,
  confirmText = 'Si',
  cancelText = 'No',
}) => {
  return (
    <div className="f-modal-confirm">
      <div className="f-modal-confirm__card">
        <ButtonClose onClick={handleCancel} />
        <div className="f-modal-confirm__body">{children}</div>
        <div className="f-modal-confirm__footer">
          {!noCancel && (
            <Button onClick={handleCancel} title="No">
              {cancelText}
            </Button>
          )}
          <Button onClick={handleConfirm} title="Si" className="--pink">
            {confirmText}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default ModalConfirm
